import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { SessionStore } from '@core/store/session.store';

export const sessionGuard: CanMatchFn = (route, segments) => {
  const session = inject(SessionStore);
  const router = inject(Router);
  const isAuthenticated = session.isAuthenticated();
  const segmentPath = segments[0]?.path ?? route.path ?? '';

  if (segmentPath === 'auth' && isAuthenticated) {
    return router.createUrlTree(['/app']);
  }

  if (!isAuthenticated) {
    if (segmentPath === 'app') {
      return router.createUrlTree(['/auth']);
    }
    return true;
  }

  return true;
};
